import { useInitPrice as useBcomInitPrice } from '@common-vue/media-card-large/src/modules/price/components/bcom';
import { useInitPrice as useMcomInitPrice } from '@common-vue/media-card-large/src/modules/price/components';

import { useBrand } from '@composables/useBrand';

/**
 *  useInitPrice parity between mcom / bcom
 * @param {ProductId} id
 * @param {object} data
 * @returns {void}
 */
export function useInitPrice({ id, data }) {
  const { isMcom } = useBrand();
  const initPrice = isMcom ? useMcomInitPrice : useBcomInitPrice;
  initPrice({ id, data });
}

export default useInitPrice;
